import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["className", "id"];
import Component from '../Component';
import classList from '../utils/classList';
import Icon from './Icon';
export default class ColorPreviewInput extends Component {
  view(vnode) {
    const _this$attrs = this.attrs,
      {
        className,
        id
      } = _this$attrs,
      otherAttrs = _objectWithoutProperties(_this$attrs, _excluded);
    const attrs = otherAttrs;
    attrs.type || (attrs.type = 'text');
    attrs.onblur = () => {
      if (attrs.value.length === 4) {
        var _attrs$onchange;
        attrs.value = attrs.value.replace(/#([a-f0-9])([a-f0-9])([a-f0-9])/, '#$1$1$2$2$3$3');
        (_attrs$onchange = attrs.onchange) == null || _attrs$onchange.call(attrs, {
          target: {
            value: attrs.value
          }
        });
      }

      // Validate the color
      if (!/^#[a-f0-9]{6}$/i.test(attrs.value)) {
        var _attrs$onchange2;
        attrs.value = '#000000';
        (_attrs$onchange2 = attrs.onchange) == null || _attrs$onchange2.call(attrs, {
          target: {
            value: attrs.value
          }
        });
      }
    };
    return m("div", {
      className: "ColorInput"
    }, m("input", Object.assign({
      className: classList('FormControl', className),
      id: id
    }, attrs)), m("span", {
      className: "ColorInput-icon",
      role: "presentation"
    }, m(Icon, {
      name: 'fas fa-exclamation-circle'
    })), m("input", Object.assign({
      className: "ColorInput-preview"
    }, attrs, {
      type: "color"
    })));
  }
}
flarum.reg.add('core', 'common/components/ColorPreviewInput', ColorPreviewInput);